import { Destructor } from '@deqo/foundation';
import React from 'react';
import { ClipboardService, ClipData } from '../../../platform/Clipboard';
import { ContainerScope, resolve } from '../../Container';
import { ContentInjector } from '../injection/ContentInjector';

export class PasteSupport extends React.Component {

    public static contextType = ContainerScope;

    @resolve(ClipboardService) private clipboard: ClipboardService;
    @resolve(ContentInjector) private injector: ContentInjector;

    private cancelListener = null as Destructor | null;

    public render = () => false;

    public componentDidMount = () => this.cancelListener = this.clipboard.on('paste', this.onPaste);
    public componentWillUnmount = () => this.cancelListener();

    private onPaste = async (clip: ClipData) => {

        const focus = document.querySelector(':focus');
        if (focus?.id !== 'tool-layer') return;

        await this.injector.injectFromClipData(clip);
    };
}
